import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { BusinessUnitsPropTypes } from '../../shared/propTypes/businessUnits';

import BusinessUnitSettingsAdminColumnRenderer from './businessUnitSettingsAdminColumnRenderer.component';
import AgGrid from '../../shared/agGrid/agGrid.component';
import columnDefs from '../../shared/columnDefinitions/businessUnits';
import { adminColumnSharedFields } from '../../shared/columnDefinitions';

const adminColumn = {
  valueGetter: ({ data }) => data,
  cellRenderer: BusinessUnitSettingsAdminColumnRenderer,
  ...adminColumnSharedFields,
};

class BusinessUnitSettingsGrid extends PureComponent {
  static propTypes = {
    businessUnits: BusinessUnitsPropTypes,
    businessUnitsLoading: PropTypes.bool.isRequired,
    shouldDisplayAdminColumn: PropTypes.bool.isRequired,
    componentToRenderOnSearchBar: PropTypes.node,
  };

  render() {
    const {
      businessUnits,
      businessUnitsLoading,
      shouldDisplayAdminColumn,
      componentToRenderOnSearchBar,
    } = this.props;

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <AgGrid
          componentToRenderOnSearchBar={componentToRenderOnSearchBar}
          columnDefs={shouldDisplayAdminColumn ? [adminColumn].concat(columnDefs) : columnDefs}
          rowData={businessUnits}
          withSearchBar
          isGridLoading={businessUnitsLoading}
        />
      </div>
    );
  }
}

export default BusinessUnitSettingsGrid;
